import { render, staticRenderFns } from "./ModulesTable.vue?vue&type=template&id=604addbf&scoped=true"
import script from "./ModulesTable.vue?vue&type=script&lang=js"
export * from "./ModulesTable.vue?vue&type=script&lang=js"
import style0 from "./ModulesTable.vue?vue&type=style&index=0&id=604addbf&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604addbf",
  null
  
)

export default component.exports